import { createSelector } from 'reselect';
import { SelectedCustomerSelector } from './customer.selectors';
export var CustomerTotalsSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  if (selectedCustomer.totals) {
    return selectedCustomer.totals.data;
  } else {
    return null;
  }
});
export var CustomerTotalsCollectionSelector = createSelector([CustomerTotalsSelector], function (data) {
  if (data && data.Totals) {
    return data.Totals;
  } else {
    return null;
  }
});
export var IsFetchingTotalsDataSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  if (selectedCustomer.totals) {
    return selectedCustomer.totals.isFetchingData;
  } else {
    return null;
  }
});
export var TotalsCountSelector = createSelector([CustomerTotalsCollectionSelector], function (totals) {
  return totals ? totals.length : null;
});